<template>
    <lv-column-text :align="align">
        <link-radio
                v-if="!!row.id && !fixedRow"
                active-icon="link-radio-inner-checked"
                inactive-icon="link-radio-inner-unchecked"
                :disabled="disabled"
                :value="value"
                @click="handleClick"/>
    </lv-column-text>
</template>

<script>
import {ColumnItemMixin} from '../mixins';
import LvColumnText from "../lv-column-text";
export default {
    name: 'link-table-column-radio-item',
    components: {LvColumnText},
    mixins: [ColumnItemMixin],
    props: {
        trueLabel: String,
        falseLabel: String,
        disabled: Boolean
    },
    computed: {
        value(){
            const fieldStr = this.row && this.field ? this.row[this.field]:this.falseLabel;
            return fieldStr === this.trueLabel;
        }
    },
    methods: {
        handleClick(){
            if(this.disabled) return;
            const newVal = !this.value?this.trueLabel:this.falseLabel;
            const oldVal = this.value?this.trueLabel:this.falseLabel;
            this.$emit('change', this.row, newVal, oldVal);
        }
    }
};
</script>
